<template>
    <Card class="resetPWCard md:p-5 w-full md:w-8 lg:w-8">
        <template #title>
            <div class="text-center Paragraph-Medium">
                Forgot Password
            </div>
        </template>
        <template #subtitle>
            <div class="text-center Caption">
                Don’t worry. We’ll send reset code to your email.
            </div>
        </template>
        <template #content>
            <div class="flex flex-column align-items-center gap-3 pt-4">
                <label for="username" class="Label align-self-start">Email</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-user" />
                    <InputText v-model="email" placeholder="Enter email here" size="small" variant="filled"
                        class="w-full" />
                </IconField>
            </div>
            <div class="flex-column flex align-items-center pt-6">
                <Button label="Get Code" class="teal-700-button" :disabled="email.length < 1" @click="generateResetCode" />
                <label for="username" class="Label pt-3 ">Remember password? <span class="Label-teal cursor-pointer"
                        @click="Login">Login</span></label>
            </div>
        </template>
    </Card>
</template>
<script setup>
import Card from 'primevue/card';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

import { useRouter } from "vue-router";
import { ref,defineEmits } from 'vue';
import * as authApi from "@/api/auth";
import { notifySuccess, notifyError } from "@/utils/notification";

const router = useRouter();
const email = ref("");

const emit = defineEmits(["to-step-two"]);

const generateResetCode = async () => {
    try {
        await authApi.generatePasswordResetToken({ email: email.value });
        notifySuccess("Success", "If the email is registered, a reset code has been sent.");
        emit("to-step-two", email.value); // Move to the next step
    } catch (err) {
        notifyError("Error", "An error occurred. Please try again and make sure the email is correct.");
    }
};
const Login = async () => {
    router.push('/login');
}
</script>
<style scoped>
.resetPWCard {
  border: none;
  box-shadow: none;
}
</style>